import { render, staticRenderFns } from "./DDEditor.vue?vue&type=template&id=07079331&"
import script from "./DDEditor.vue?vue&type=script&lang=js&"
export * from "./DDEditor.vue?vue&type=script&lang=js&"
import style0 from "./DDEditor.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports